export class AlfatronScu61e {
    constructor(socket) {
        this.socket = socket;
        this.analogOutputEnabled = true;
        this.autoSwitch = false;
        this.firmwareVersion = '1.0.0';
        this.fpLocked = false;
        this.power = true;
        this.tosLinkOutputEnabled = true;
        this.videoMatrixRoutes = '1';
        this.asyncHandlers = [
            {
                name: 'analogAudio',
                regExp: /^IIS(ON|OFF)/i,
                callback: (match) => {
                    if (this.power) {
                        this.analogOutputEnabled = match[1].toUpperCase() === 'ON';
                        this.socket.send(`IIS OUT ${this.analogOutputEnabled ? 'ON' : 'OFF'}`);
                    }
                },
            },
            {
                name: 'autoSwitchSet',
                regExp: /^HDMI(A|M)/i,
                callback: (match) => {
                    if (this.power) {
                        this.autoSwitch = match[1].toUpperCase() === 'A';
                        this.socket.send(`HDMI OUT SWITCH TO ${this.autoSwitch ? 'AUTO' : 'MANUAL'} MODE!`);
                    }
                },
            },
            {
                name: 'fpLock',
                regExp: /^(UN)?LOCK/i,
                callback: (match) => {
                    if (this.power) {
                        this.fpLocked = match[1] === undefined;
                        this.socket.send(`FRONT PANEL ${this.fpLocked ? 'LOCKED' : 'UNLOCK'}!`);
                    }
                },
            },
            {
                name: 'getIp',
                regExp: /^GETGUIIP/i,
                callback: (match) => {
                    if (this.power)
                        this.socket.send(`GUI IP:192.168.0.178!`);
                },
            },
            {
                name: 'powerSet',
                regExp: /^POW(ON|OFF)/i,
                callback: (match) => {
                    this.power = match[1].toUpperCase() === 'ON';
                    this.socket.send(`POWER ${match[1]}!`);
                },
            },
            {
                name: 'status',
                regExp: /^STA/i,
                callback: (match) => {
                    if (this.power) {
                        const status = [
                            'GUI/RS232 QUERY STATUS!',
                            'SCU61E',
                            `VERSION V${this.firmwareVersion}`,
                            `POWER ${this.power ? 'ON' : 'OFF'}!`,
                            `HDMI OUT SWITCH TO ${this.autoSwitch ? 'AUTO' : 'MANUAL'} MODE!`,
                            `FRONT PANEL ${this.fpLocked ? 'LOCKED' : 'UNLOCK'}!`,
                            `HDMI OUT SWITCH TO ${this.videoMatrixRoutes}!`,
                            `DIP0000!`,
                            `DIP EDID0000!`,
                            `SPDIF OUT ${this.analogOutputEnabled ? 'ON' : 'OFF'}!`,
                            `IIS OUT ${this.tosLinkOutputEnabled ? 'ON' : 'OFF'}!`,
                        ];
                        status.forEach(st => this.socket.send(st));
                    }
                },
            },
            {
                name: 'toslink',
                regExp: /^SPDIF(ON|OFF)/i,
                callback: (match) => {
                    if (this.power) {
                        this.tosLinkOutputEnabled = match[1].toUpperCase() === 'ON';
                        this.socket.send(`SPDIF OUT ${this.tosLinkOutputEnabled ? 'ON' : 'OFF'}`);
                    }
                },
            },
            {
                name: 'videoMatrixRoutesSet',
                regExp: /^HDMI(\d+)/i,
                callback: (match) => {
                    if (this.power) {
                        this.videoMatrixRoutes = match[1];
                        this.socket.send(`HDMI OUT SWITCH TO ${this.videoMatrixRoutes}!`);
                    }
                },
            },
        ];
        this.commandExtractor = {
            terminators: ['.'],
        };
        this.sendTerminator = '\r\n';
    }
}
AlfatronScu61e.emulatorType = 'socketEmulator';
AlfatronScu61e.key = '-MwND6WsiByd2LjFPlJr';
